import { createSlice } from '@reduxjs/toolkit';
import type { IInvoice } from '@/common/interfaces/invoice.interface';
import { INVOICE_DATA } from '@/common/mocks/invoiceData';

const initialState = {
  orderItems: [],
  invoice: INVOICE_DATA as IInvoice,
};

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrderItems: (state, action) => {
      state.orderItems = action.payload;
    },
    setInvoice: (state, action) => {
      state.invoice = action.payload;
    },
  },
});

/** Action creators are generated for each case reducer function */
export const { setOrderItems, setInvoice } = ordersSlice.actions;

export default ordersSlice.reducer;
